<template>
  <div 
    v-if="!waitForResponse" 
    class="step subscribe-step">
    <div class="step-header">
      <h3>Choose your payment method</h3>
      <select
        v-if="paymentMethods"
        @change="selectPaymentMethod($event)">
        <option
          value=""
          disabled
          selected>Select your payment method</option>
        <option
          v-for="method in paymentMethods"
          :key="method.id"
          :value="method.id"
          class="dropdown-form-item">
          {{ method.brand }} Last four {{ method.last_four }}
          Expired:{{ method.exp_month }}/{{ method.exp_year }}
        </option>
      </select>
    </div>

    <div class="step-body package-item">
      <div>
        <h4>You choose</h4>
        <PackageItem
          :months="plan.interval_count"
          :price="plan.amount"/>
        <h4><a
          href="#"
          class="subscribe"
          @click.prevent="subscribe">Subscribe</a></h4>
      </div>
    </div>

    <div class="step-footer">
      <div class="add-method">
        You can add payment method <a
          href="#"
          @click.prevent="goToSettings">here</a>
      </div>

      <a
        href="#"
        @click.prevent="goToPackage">return to Choose packages</a>
    </div>
  </div>
  <div
    v-else
    class="save-data-animation">
    <img :src="getImageUrl('/images/animations/saving.svg')">
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";
import {mapActions, mapGetters} from "vuex";
import PackageItem from "./PackageItem";
import Swal from 'sweetalert2'

export default {
    components: {PackageItem},
    mixins: [profileMixin],

    props: {
        plan: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        formData: {},
        waitForResponse: false,
        currentPaymentMethod: ''
    }),

    computed: {
        ...mapGetters(['user', 'plans', 'paymentMethods'])
    },

    created() {
        this.loadPaymentMethodsData();
    },

    methods: {
        ...mapActions(['loadPaymentMethods', 'updateSubscription', 'fetchUser']),

        loadPaymentMethodsData() {
            this.loadPaymentMethods();
        },

        goToPackage() {
            this.$emit('prevStep');
        },

        goToSettings() {
            this.showModal(false);
            this.$router.push({name: 'Account settings'});
        },

        selectPaymentMethod($event) {
            this.currentPaymentMethod = $event.target.value;
        },

        subscribe() {
            if (this.currentPaymentMethod) {
                this.formData['plan'] = this.plan.id;
                this.formData['payment'] = this.currentPaymentMethod;
                this.waitForResponse = true;

                this.updateSubscription(this.formData).then(() => {
                    this.showModal(false);
                    Swal.fire({
                        type: 'warning',
                        title: 'Success subscription',
                        text: '',
                        reverseButtons: true,
                        confirmButtonText: 'Ok'
                    }).then(() => {
                        this.fetchUser();
                        this.$router.push({name: 'Hair regimen'});
                    })
                });

            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/steps/SubscribeForm.vue